import './ModalComponent.css'
import { DialogContent, DialogTitle, DialogContentText, DialogActions, Button, Dialog} from "@mui/material";
import React from 'react'

const ModalComponent = (props) => {

  return (
    <Dialog open={props.show}
      onClose={props.cancelModal}
      aria-labelledby="alert-Modal-title"
      aria-describedby="alert-Modal-description" >
        <DialogTitle id="alert-Modal-title">Start Test</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-Modal-description">
          This will take about {props.processingTime} seconds. Do you want to proceed? <br/><br/>
          A copy of the results will be emailed to
           <span style={{ "color": "#367c2b" }}> {props.useremail}</span>.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
      <Button variant="secondary" onClick={props.refreshHandler}>Cancel</Button>
      <Button variant="primary" onClick={props.cancelModal}>Continue</Button>
      </DialogActions>
    </Dialog>

  )
}

export default ModalComponent
